import config from 'src/config';
import api from './api';

export const deleteAllChats = () => {
	const DELETE_SESSIONS_ENDPOINT = config.VERSION_ENDPOINT + 'chat-session';
	api.delete(DELETE_SESSIONS_ENDPOINT);
};
